<template>
    <div class="widget-container">
      <!--<div class="contact-info-title">DineSafeVT</div>
      <div class="blue-bar"></div>-->

      <!-- :data-source="companies" -->
      <!--<p>Table: {{this.$route.query.tableId}}</p>-->

        <TermsPopup
          ref="termsPopupRef"
          :termsVisible="false"
        >
        </TermsPopup>

        <DxPopup
          ref="submitPopupRef"
          :visible.sync="submitted"
          :drag-enabled="true"
          :close-on-outside-click="true"
          :show-title="true"
          :width="280"
          :height="465"
          @hidden="popupHidden"
          title=""
        >      
          <SuccessPage
            :firstName="firstName"
            :lastName="lastName"
            :accountName="accountName"
            :menuURL="menuURL"
          />          
        </DxPopup>
      <form
        action="submit"
        @submit="onSubmitClick"
      >
      <DxForm
        id="form"
        ref="contactInfoFormRef"        
        :form-data.sync="contactInfo"
        :read-only="readOnly"
        :show-colon-after-label="showColon"
        :show-validation-summary="false"
        :label-location="labelLocation"
        :min-col-width="minColWidth"
        action="submit"
        @fieldDataChanged="formContentReady"
      >
        <DxGroupItem
          :col-count="4"
        >
          <DxSimpleItem 
            name="Location"
            data-field="Location"
            :col-span="4"
            editor-type="dxTextBox"
            :editor-options= "{placeholder:'Location', stylingMode:'underlined', color:'white'}"
            :label="itemLabel"                              
            :visible="false"
          >
          </DxSimpleItem>
          
          <!-- :editor-options= "{placeholder:'Location', stylingMode:'outlined', color:'white'}"  -->
          <!-- Loop through the json items, and create input boxes in the form for each item -->
          <DxSimpleItem 
            v-for="item in contactInfoFields" :key="item.AttributeId"
            :data-field="item.FieldName"
            :label="itemLabel"
            :editor-options="{
                                placeholder: item.DisplayText,                                
                                //When FieldName = Phone or ZipCode, set the mask appropriately
                                mask: item.FieldName == 'Phone' ? '1 (000) 000-0000' : '',
                                showMaskMode: 'onFocus', //Only show the mask if the field has focus.  Without focus, the label shows
                                items: item.FieldName == 'StateProvince' ? states : null,
                                value: item.FieldName == 'StateProvince' ? 'VT' : null,
                                stylingMode:'outlined',
                                mode: item.FieldName == 'Email' ? 'email' 
                                  : item.FieldName == 'Phone' ? 'tel'
                                  : 'text' //default to text
                              }"         
            :col-span="item.ColumnSpan"
            :editor-type="item.FieldName == 'StateProvince' ? 'dxSelectBox' : null"
          >
              <!-- Set the "required" value based on the value of FieldName.isRequired -->
              <DxRequiredRule v-if="item.IsRequired" :message="item.DisplayText + ' is required'"  />
          </DxSimpleItem>

          <!--<DxSimpleItem 
            data-field="PostalCode"
            :label="itemLabel"
            :editor-options= "{placeholder:'Postal Code'}"
            :col-span="2"
          />-->
          
          <DxSimpleItem
            ref="chkRememberMe"
            :col-span="4"
            :editor-options="chkRememberMeOptions"
            data-field="RememberMe"
            editor-type="dxCheckBox"
          >
            <DxLabel :visible="false"/>            
          </DxSimpleItem>   

          <DxSimpleItem
            ref="chkShareMyInfo"
            :col-span="4"
            :editor-options="chkShareMyInfoOptions"
            data-field="ShareMyInfo"
            editor-type="dxCheckBox"
          >
            <DxLabel :visible="false"/>            
          </DxSimpleItem>

          <DxSimpleItem
            :col-span="2"
            data-field="TermsAndConditions"
          >
            <DxLabel :visible="false"/>  
            <DxRequiredRule 
              message="You must accept the Terms and Conditions"  
            />
            <template #default>
                <div class="terms-and-conditions-container">
                  <DxCheckBox
                    text="I agree to the "
                    @value-changed="chkAgreeToTermsChanged"
                    validation-message-mode="auto"
                  >
                  </DxCheckBox>              
                  <DxButton
                    ref="btnTermsRef"
                    text="Terms and Conditions"
                    styling-mode="text"
                     @click="btnTermsClick($event)"
                    :element-attr="{
                        id: 'btnTermsAndConditions',
                        class: 'btn-terms-and-conditions',  //I set a class here so I can style the button like a hyperlink
                      }"
                  />
                </div>
            </template>
          </DxSimpleItem>     
    </DxGroupItem>

    <DxGroupItem
      :col-count="2"
      :colCountByScreen="{
        xs: 2,
        sm: 2,
      }"
    >
      <DxButtonItem
          ref="btnSubmitRef"
          :col-span="1"
          :button-options.sync="submitButtonOptions"
          horizontal-alignment="right"
        />
        <DxButtonItem
        ref="btnResetRef"
          :col-span="1"
          :button-options="resetButtonOptions"
          horizontal-alignment="left"
          item-type="button"
        />    
    </DxGroupItem>

  </DxForm>
  </form>
  </div>
</template>
<script>

import {DxButton} from 'devextreme-vue';
import { DxCheckBox } from 'devextreme-vue/check-box';
import {DxForm, DxSimpleItem, DxCompareRule, DxLabel, DxGroupItem, DxRequiredRule, DxPatternRule, DxButtonItem, DxEmptyItem} from 'devextreme-vue/form';
import service from '../data/contact-info-data';
import notify from 'devextreme/ui/notify';
import shared from '../utils/contact-tracing-functions';
import DxPopup from 'devextreme-vue/popup';
import TermsPopup from '../components/terms-and-conditions';
import SuccessPage from '../views/success-page';

export default {
  components: {
    DxForm,
    DxButton,
    DxSimpleItem, 
    DxCompareRule,
    DxLabel,
    DxGroupItem,
    DxRequiredRule,
    DxPatternRule,
    DxButtonItem,
    DxEmptyItem,
    DxPopup,
    DxCheckBox,
    TermsPopup,
    SuccessPage,
  },
  data() {
    const contactInfo = service.getContactInfo();
    const states = service.getStates();

    return {
      firstName: '',
      lastName: '',
      accountName: '',
      menuURL: '',
      submitted: false,
      submitButtonDisabled: false,
      contactInfoFields: service.getContactInfoFields()[0].Fields,
      labelLocation: 'top',
      readOnly: false,
      showColon: true,
      minColWidth: 300,   
      states:states,
      contactInfo: contactInfo[0],
      width: null,
      tablId: this.$route.query.tableId, //Get the tableId from the query parameters in the URL that was scanned.
      rememberMeChecked: null,
      
      chkTermsOptions: {
        text: 'I agree to the Terms and Conditions',
      },
      chkRememberMeOptions: {
        text: 'Remember Me',
        onValueChanged: this.chkRememberMeChanged,
        value: false,
      },
      chkShareMyInfoOptions: {
        text: 'Check this box if you want participating restaurants to know your details so they can contact you with special offers etc.',
        onValueChanged: this.chkShareMyInfoChanged,
        value: false,
      },
      locationButtonOptions: {
        type: 'normal',
        text: 'Scan QR Code',
        onClick: 
          function(e){
            //"this" is the Button
            //this.onResetClick(e);
            console.log("QR Button Clicked");          
        }
      },
      resetButtonOptions: {
        type: 'danger',
        text: 'Reset',
        height: "40",
        onClick: this.onResetClick,
      },
      submitButtonOptions: {
        type: 'success',
        text: 'Submit',
        width: '120',
        height: "40",
        useSubmitBehavior: true,
        disabled: false,
        //Note - The click function is defined at the FORM level -- @submit="onSubmitClick"
      },
      namePattern: /^[^0-9]+$/,
      stateOptions: {
        items: states,
        placeholder:'State/Province',
      },
      phoneOptions: { 
        mask: '+1 (000) 000-0000',
        placeholder:'Phone Number',
        showMaskMode: 'onFocus',
      },
      itemLabel: {
        visible: false,
      },
      phoneItemLabel: {
        visible: true,
      }
    };
  },
  computed: {
    xsubmitButtonOptions: function(){
        return [
        {         
            type: 'success',
            text: 'Submit',
            width: '120',
            height: "40",
            useSubmitBehavior: true,
            disabled: false,
            //Note - The click function is defined at the FORM level -- @submit="onSubmitClick"
        }        
      ]
    }
  },
  created(){
    
  },
  mounted(){
    //This method fires AFTER all the components are instantiated

    //Update the Table value to be the tableid from the url query string
    //this.$refs.contactInfoFormRef.instance.updateData("Location", this.$route.query.tableId);

    this.$refs.contactInfoFormRef.instance.updateData("Location", this.$route.params.locationCode)

    //If there is data in localStorage
    if(localStorage.dinesafeContactInfo != null){
      //Load saved data from localStorage to the form
      this.$refs.contactInfoFormRef.instance.updateData(JSON.parse(localStorage.dinesafeContactInfo));

      //this.formIsLoaded = true;
    }

    //Get the 6-character LocationCode from the QR code URL that was scanned
    this.$refs.contactInfoFormRef.formData.LocationCode = this.$route.params.locationCode;

    //Get the LocationId from the database
    this.GetLocationId(this.$route.params.locationCode);
  },
  methods:{
    /*
      Pass the LocationURL and get the LocationId
      Stored Proc = pr_GetLocationId
    */
    GetLocationId(locationCode){
      this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetLocationId',
      {
          LocationURL: this.$store.state.appSettings.locationURLprefix + locationCode,
      }
      ).then(function(data){         
        if(data.body != null && data.body != ''){
          var responseData = JSON.parse(data.body);
          
          //Store the LocationId
          this.$refs.contactInfoFormRef.formData.LocationId = responseData[0].LocationId;
          this.accountName = responseData[0].AccountName;
          this.menuURL = responseData[0].MenuURL;

          //AJT ToDo - If the user is logged in, submit the data, show a Success message

          //Check LocalStorage values - UserId (Guid), LoggedIn (bool)
          if(localStorage.dinesafeUser != null){
            var userInfo = JSON.parse(localStorage.dinesafeUser);


            //If UserId has a value and LoggedIn = true, pass the UserId and LocationId to a method that will save a Visit to the database
            // shared.somethingsomething
            if(userInfo.UserId != null && userInfo.LoggedIn){
              //Log a visit record to the database

              //Populate the form.  We still need some data such as FirstName, LastName, to send to the SUCCESS page
              //Get the User Information
              this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetUserData',
              {       
                  UserId: userInfo.UserId,
              }
              ).then(function(data){         
                  if(data.body != null && data.body != ''){
                      var responseData = JSON.parse(data.body);      

                      this.$data.contactInfo = responseData[0];                  
                  }
              });

              //Save the Contact Info data to the database
              //Stored Proc = pr_user_autoFillContactInfo
              this.$http.post(this.$store.state.appSettings.webServiceUrl + 'CreateLoggedInLocationRecord',
              {
                  //LocationId: rowData.LocationId == null ? null : rowData.LocationId
                  LocationId: responseData[0].LocationId,
                  UserId: userInfo.UserId,
              }
              ).then(function(data){         
                   if(data.body != null && data.body != ''){
                        var responseData = JSON.parse(data.body);      

                        //var message = responseData[0].Message;

                        //Navigate to the Success-Page
                        //this.$router.push( to="/success");

                        this.$router.push({ 
                          name: 'success-page', 
                          params: { 
                            firstName: this.$data.contactInfo.FirstName, 
                            lastName: this.$data.contactInfo.LastName, 
                            accountName: this.accountName,
                            menuURL: this.menuURL, 
                          } 
                        })
                    }
              });
            }
            else if(userInfo.UserId != null && !userInfo.LoggedIn){
              //Future Todo - If UserId has a value and LoggedIn = false, navigate to the LoginForm
            }
          }          

          //If the user navigated to this page, THEN logged in, 
          //  Get the user's info, Populate the form, submit the form.
        }
        else{
          console.log("Error 001 - Invalid Location");

           notify({
            message: "Invalid location", 
            type:'warning', 
            width:'auto', 
            displayTime: 2000,
            position: {
              my: 'center center',
              at: 'center center'
            }
          });

          //Navigate to the QR Reader page
          this.$router.push("/home");
        }
      });
    },
    /*
      Reset the values on the form
    */
    onResetClick(e){
      //console.log("Reset Clicked");
      //Clear the form
      this.$refs.contactInfoFormRef.instance.resetValues();

      //Set the Location and Table (basically, don't reset these values)
      this.$refs.contactInfoFormRef.instance.updateData("Location", this.$route.query.tableId);
      //this.$refs.contactInfoFormRef.instance.updateData("Table", this.$route.query.tableId);
    },
    onSubmitClick(e){
      //If "Remember me" is checked, save the contact info to localStorage
      if(this.rememberMeChecked){
        localStorage.dinesafeContactInfo = JSON.stringify(this.$refs.contactInfoFormRef.formData);
      }

      this.firstName = this.contactInfo.FirstName;
      this.lastName = this.contactInfo.LastName;

      //Validate the form
      var valid = this.$refs.contactInfoFormRef.instance.validate();

      //Show feedback
      var type = 'success';
      var toastMessage = 'Your info was submitted';
      var toastWidth = 100;
      var showToast = true;

      if(valid.isValid)
      {        
        //this.$refs.contactInfoFormRef.resetValues();
        //this.$refs.contactInfoFormRef.formData = null;

        var formData = this.$refs.contactInfoFormRef.formData;

        //Save the Contact Info data to the database
        // shared.saveContactInfo(this, this.$refs.contactInfoFormRef.formData); 
        //this.saveContactInfo(this.$refs.contactInfoFormRef.formData); 
        this.$http.post(this.$store.state.appSettings.webServiceUrl + 'SaveContactInfo',
        {
            //LocationId: rowData.LocationId == null ? null : rowData.LocationId
            //Note - AccountId is not needed here, the LocationId can be used in the stored proc to determine the AccountId if needed
            Address: formData.Address,
            Address1: formData.Address1,
            City: formData.City,
            Email: formData.Email,
            FirstName: formData.FirstName,
            LastName: formData.LastName,
            LocationId: formData.LocationId,          
            Phone: formData.Phone,          
            State: formData.StateProvince,
            Zip: formData.ZipCode,
            ShareMyInfo: formData.ShareMyInfo,
        }
        ).then(function(data){         
            //var responseData = JSON.parse(data.body);        
            //console.log("Done saving " + responseData);

            //Display the popup
            //this.submitted = true; 

            this.$router.push({ 
              name: 'success-page', 
              params: { 
                firstName: this.firstName, 
                lastName: this.lastName, 
                accountName: this.accountName,
                menuURL: this.menuURL, 
              } 
            })
        });
       
        //Display the popup
        //this.submitted = true; 

        //Clear the form
        //this.$refs.contactInfoFormRef.instance.resetValues();        
      }
      else if(valid.brokenRules.length > 0)
      {
        //showToast = false;

        //Don't show the popup
        this.submitted = false; 
      }
      else
      {      
        //The submit failed
        type = 'failure';
        toastMessage = 'There was an error submitting your info';
        toastWidth = 200;
      }

      /*if(showToast)
      {
        //Show the success/fail message
        notify(
            {message: toastMessage, 
            type:type, 
            width:toastWidth, 
            displayTime: 2000,
            position: {
            my: 'center center',
            at: 'center center'
          }}
        );
      }*/

      //Prevent the form from closing
      //This is only required if I am using the DxButtonItem as opposed to a DxButton for the Submit action
      e.preventDefault();      
    },
    /*
      Save a ContactInfo record.
      A new record will be added to the DB if needed.
      If a record already exists for the LocationId/Email combo, it will be updated.  This may be changed in the future.
      Stored Proc = pr_customer_saveResponse
    */
    x_saveContactInfo(formData){
      this.$http.post(this.$store.state.appSettings.webServiceUrl + 'SaveContactInfo',
      {
          //LocationId: rowData.LocationId == null ? null : rowData.LocationId
          //Note - AccountId is not needed here, the LocaitonId can be used in the stored proc to determine the AccountId if needed
          Address: formData.Address,
          Address1: formData.Address1,
          City: formData.City,
          Email: formData.Email,
          FirstName: formData.FirstName,
          LastName: formData.LastName,
          LocationId: formData.LocationId,          
          Phone: formData.Phone,          
          State: formData.StateProvince,
          Zip: formData.ZipCode,
      }
      ).then(function(data){         
          //var responseData = JSON.parse(data.body);        
          //console.log("Done saving " + responseData);
      });
    },
    popupHidden(){
      //console.log("popupHidden");
     
      //Clear the form
      //this.$refs.contactInfoFormRef.instance.resetValues();        
    },
    onCheckClick(e){
      //console.log("checkClick");

      //Hide the popup
      this.submitted=false;
    },
    btnTermsClick(e){
      //console.log("btnTermsClick");

      //Show the Terms and Conditions
      this.$refs.termsPopupRef.$data.termsVisibleYN = true;
    },
    formContentReady(e){
      //console.log("formContentReady");
    },
    chkRememberMeChanged(e){
      //console.log("chkRememberMeChanged");

      this.rememberMeChecked = e.value;
    },
    chkShareMyInfoChanged(e){
      //console.log("chkShareMyInfoChanged");

      //this.rememberMeChecked = e.value;
    },
    chkAgreeToTermsChanged(e){
      console.log("chkAgreeToTermsChanged");

      //this.$refs.btnSubmitRef.$options.propsData.buttonOptions.disabled = false; //e.value;
      //this.submitButtonDisabled = false;

      //this.submitButtonOptions.disabled = true;
      //this.$data.submitButtonOptions.disabled = true;

      /*this.submitButtonOptions =       
      {
        type: 'success',
        text: 'Submit',
        width: '120',
        height: "40",
        useSubmitBehavior: true,
        disabled: true,
        //Note - The click function is defined at the FORM level -- @submit="onSubmitClick"
       };

       e.cancel = true;*/
    },
  }
};
</script>

<style>
  @import '../themes/contact-tracing.css'; 
</style>

